import { Component, OnInit } from '@angular/core';
import { VariableTypeEnum } from '../../../shared/ontology/variable-type.enum';
import { StudyEditorContext } from '../../study-editor.context';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BreedingMethodModalService } from '../../../shared/breeding-method/service/breeding-method-modal.service';
import { Principal } from '../../../shared';
import { DatasetService } from '../../../shared/dataset/service/dataset.service';
import { AlertService } from '../../../shared/alert/alert.service';
import { StudyEntryFilter } from '../../../shared/study/model/study-entry-request.model';
import { ObservationVariable } from '../../../shared/model/observation-variable.model';
import { VariableDetails } from '../../../shared/ontology/model/variable-details';
import { DatasetVariable } from '../../../shared/study/model/dataset-variable';
import { StudyInstanceService } from '../../../shared/study/service/study-instance.service';
import { ObservationUnitsSearchRequest } from '../../../shared/dataset/model/observation-units-search-request.model';
import { ObservationUnitsSearchResponse } from '../../../shared/dataset/model/observation-units-search-response.model';
import { ObservationUnitData } from '../../../shared/dataset/model/observation-unit-data.model';
import { StudyInstanceObservation } from '../../../shared/study/model/study-instance-observation.model';
import { StudyInstanceDescriptor } from '../../../shared/study/model/study-instance-descriptor.model';
import { StudyInstanceModel } from '../../../shared/dataset/model/study-instance.model';
import { Location } from '../../../shared/location/model/location';
import { CategoricalMatchByEnum, GenericDatasetComponent } from '../dataset/generic-dataset.component';
import {
    ADD_ENVIRONMENT_DETAILS_VARIABLES_PERMISSIONS,
    ADD_ENVIRONMENTAL_CONDITIONS_VARIABLES_PERMISSIONS,
    MODIFY_ENVIRONMENT_VALUES_PERMISSIONS,
    MODIFY_NUMBER_OF_ENVIRONMENT_PERMISSIONS
} from '../../../shared/auth/permissions';
import { ModalConfirmComponent } from '../../../shared/modal/modal-confirm.component';
import { TranslateService } from '@ngx-translate/core';
import { FileService } from '../../../shared/file/service/file.service';
import { ColumnData } from '../../shared/models/column-data.model';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { ColumnDataService } from '../../shared/services/column-data.service';
import { FileManagerComponent } from '../../../file-manager/file-manager.component';
import { HELP_MANAGE_STUDIES_ENVIRONMENT } from '../../../app.constants';
import { DerivedVariableService } from '../../shared/services/derived-variable.service';
import { VariableUtilityService } from '../../shared/services/variable-utility.service';
import { StudyEditorService } from '../../study-editor.service';

@Component({
    selector: 'jhi-study-environments',
    templateUrl: './study-environments.component.html',
    styleUrls: ['./study-environments.component.scss']
})
export class StudyEnvironmentsComponent extends GenericDatasetComponent implements OnInit {

    protected readonly COOPERATOR_ID_TERMID = 8372;
    protected readonly COOPERATOR_NAME_TERMID = 8373;
    protected readonly LOCATION_NAME_TERMID = 8180;
    protected readonly LOCATION_ID_TERMID = 8190;
    private readonly LOCATION_ABBR_TERMID = 8189;

    protected readonly CategoricalMatchByEnum = CategoricalMatchByEnum;
    protected readonly ADD_ENVIRONMENTAL_CONDITIONS_VARIABLES_PERMISSIONS = ADD_ENVIRONMENTAL_CONDITIONS_VARIABLES_PERMISSIONS;
    protected readonly ADD_ENVIRONMENT_DETAILS_VARIABLES_PERMISSIONS = ADD_ENVIRONMENT_DETAILS_VARIABLES_PERMISSIONS;
    protected readonly MODIFY_NUMBER_OF_ENVIRONMENT_PERMISSIONS = MODIFY_NUMBER_OF_ENVIRONMENT_PERMISSIONS;
    protected readonly HELP_MANAGE_STUDIES_ENVIRONMENT = HELP_MANAGE_STUDIES_ENVIRONMENT;

    private readonly HIDE_STUDY_ENVIRONMENT_FIELDS = [8170, 8189, 8180];
    private readonly HIDE_STUDY_VARIABLE_DBCV_FIELDS = [8100, 8180, this.COOPERATOR_NAME_TERMID, this.LOCATION_NAME_TERMID, this.LOCATION_ABBR_TERMID];
    private readonly EXP_DESIGN_VARIABLES = [8135, 8131, 8842, 8132, 8133, 8134, 8136, 8137, 8138, 8139, 8142, 8165, 8831, 8411, 8412, 8413];
    private readonly SYSTEM_VARIABLE_EXEMPTIONS = [this.LOCATION_ABBR_TERMID];

    // List of variables to hide from the variables table
    public HIDE_FROM_VARIABLES_TABLE = [...this.HIDE_STUDY_ENVIRONMENT_FIELDS, ...this.HIDE_STUDY_VARIABLE_DBCV_FIELDS, ...this.EXP_DESIGN_VARIABLES];
    public HIDE_FROM_VARIABLES_SELECTOR = [...this.HIDE_STUDY_ENVIRONMENT_FIELDS, ...this.EXP_DESIGN_VARIABLES];
    public HIDE_FROM_TABLE = [...this.EXP_DESIGN_VARIABLES, this.COOPERATOR_NAME_TERMID];


    trialInstances: { [key: string]: StudyInstanceModel } = {};
    numberOfEnvironments: any;
    newNumberOfenvironments: any;

    environmentDetails: ColumnData[] = [];
    environmentConditions: ColumnData[] = [];
    showStudyEntriesTable = true;

    columnDataService: ColumnDataService;
    isFileStorageConfigured: boolean;
    hoveredRow: number | null = null;

    constructor(
        private breedingMethodModalService: BreedingMethodModalService,
        private datasetService: DatasetService,
        private alertService: AlertService,
        private studyInstanceService: StudyInstanceService,
        public studyEditorContext: StudyEditorContext,
        protected modalService: NgbModal,
        protected principal: Principal,
        protected translateService: TranslateService,
        private fileService: FileService,
        private derivedVariableService: DerivedVariableService,
        private variableUtilityService: VariableUtilityService,
        private studyEditorService: StudyEditorService
    ) {
        super(studyEditorContext, modalService, translateService, principal);
    }

    isReloadPending: boolean;
    reloadDelay: number = 300;
    reloadTimeout: any;


    /**
     * Efficiently reload study settings by delaying call to load settings to allow batching.
     */
    scheduleReload(): void {
        if (this.isReloadPending) {
            // If a reload is already scheduled, reset the delay (debouncing)
            clearTimeout(this.reloadTimeout);
        } else {
            this.isReloadPending = true; // Indicate that a reload has been scheduled
        }

        // Schedule the reload after the specified delay
        this.reloadTimeout = setTimeout(() => {
            this.loadTable();
            this.isReloadPending = false; // Reset pending flag after reload
        }, this.reloadDelay);
    }

    ngOnInit(): void {
        this.selectedItems.clear();
        this.currentDataset = this.studyEditorContext.getEnvironmentDataset();
        this.studyEditorContext.currentDataset = this.currentDataset;
        this.fileService.isFileStorageConfigured().then((isFileStorageConfigured) => {
            this.isFileStorageConfigured = isFileStorageConfigured;
        });
        this.columnDataService = new ColumnDataService(ColumnDataService.STUDY_ENVIRONMENTS_KEY, String(this.currentDataset.datasetId));
        super.ngOnInit();
    }

    loadDataset(datasetId: number): Promise<void> {
        throw new Error('Method not implemented.');
    }

    async loadTable(): Promise<void> {
        const instances = await this.studyInstanceService.listStudyInstances(this.studyEditorContext.studyDetails.id).toPromise();
        this.trialInstances = instances.reduce((acc: { [key: string]: StudyInstanceModel }, instance) => {
            acc[instance.instanceNumber] = instance;
            return acc;
        }, {});
        this.numberOfEnvironments = instances?.length;
        this.newNumberOfenvironments = instances?.length;
        await this.loadTableHeader();
        this.loadTableData();
    }

    async loadTableHeader(): Promise<void> {
        return this.datasetService.getObservationSetColumns(this.studyEditorContext.studyDetails.id, this.currentDataset.datasetId).toPromise().then((response) => {
            let columnsFromResponse = response.body as ColumnData[];
            columnsFromResponse.forEach(column => {
                column.columnSelectorVisible = column.selected = column.visible = (column.termId !== this.LOCATION_NAME_TERMID && column.termId !== this.LOCATION_ABBR_TERMID);
            });
            columnsFromResponse.unshift({
                alias: '',
                factor: true,
                name: 'FILES',
                termId: this.STATIC_COLUMN_FILES,
                displayName: '',
                visible: this.isFileStorageConfigured,
                columnSelectorVisible: this.isFileStorageConfigured,
                selected: this.isFileStorageConfigured,
                variableTypeId: 0,
                id: 0,
                possibleValuesById: undefined,
                possibleValuesByName: undefined,
                enableFilterSorting: false,
                deletable: false,
                hidden: false,
                inputVariables: ''
            });

            columnsFromResponse.unshift({
                alias: '',
                factor: true,
                name: '',
                termId: this.CHECKBOX,
                displayName: '',
                visible: true,
                columnSelectorVisible: true,
                selected: true,
                variableTypeId: 0,
                id: 0,
                possibleValuesById: undefined,
                possibleValuesByName: undefined,
                enableFilterSorting: false,
                deletable: false,
                hidden: false,
                inputVariables: ''
            });

            columnsFromResponse = columnsFromResponse.filter(column => !this.HIDE_FROM_TABLE.includes(column.termId));

            columnsFromResponse.forEach(column => {
                // Special Handling:
                // Set the LOCATION_ID variable alias as LOCATION_NAME
                if (column.termId === this.LOCATION_ID_TERMID) {
                    column.displayName = 'LOCATION_NAME';
                    column.alias = 'LOCATION_NAME';
                }
                // Special Handling:
                // If the variable is COOPERATOR_ID, dislay it as COOPERATOR
                if (column.termId === this.COOPERATOR_ID_TERMID) {
                    column.displayName = 'COOPERATOR';
                    column.alias = 'COOPERATOR';
                }
            });

            this.displayedColumns = this.columnDataService.processColumns(columnsFromResponse, this.displayedColumns);
            this.displayedColumns = this.columnDataService.applyColumnsState();
            this.groupColumns(this.displayedColumns);


        });
    }

    loadTableData(pageIndex = 1, pageSize = 50): void {
        const request: ObservationUnitsSearchRequest = new ObservationUnitsSearchRequest();
        request.environmentConditions = this.transformObservationVariableToDTO(this.environmentConditions);
        request.environmentDetails = this.transformObservationVariableToDTO(this.environmentDetails);
        request.environmentDatasetId = this.currentDataset.datasetId;
        const pagination: any = {
            page: pageIndex - 1,
            size: pageSize,
            sort: this.getSort(),
        };
        this.datasetService.getObservationUnitTable(this.studyEditorContext.studyDetails.id, this.currentDataset.datasetId, request, pagination).toPromise().then((response) => {
            this.numberOfItems = Number(response.headers.get('X-Total-Count'));
            this.items = response.body;
        });
    }

    private groupColumns(columns: ColumnData[]): void {

        this.environmentDetails = [];
        this.environmentConditions = [];

        const columnsData = [...columns];

        columnsData.forEach(columnData => {
            if (columnData.variableTypeId === VariableTypeEnum.ENVIRONMENT_DETAIL) {
                this.environmentDetails.push(columnData);
            } else if (columnData.variableTypeId === VariableTypeEnum.ENVIRONMENT_CONDITION) {
                this.environmentConditions.push(columnData);
            }
        });
    }

    getFilter(): StudyEntryFilter {
        return {
            entryNumbers: [],
            entryIds: [],
            filteredValues: this.displayedColumns.reduce((map, column) => {
                column.isFiltered = false;
                if (column.possibleValues) {
                    const selectedValues = column.possibleValues
                        .filter(value => value.isSelectedInFilters)
                        .map(value => value.name);
                    if (selectedValues.length > 0) {
                        map[column.termId] = selectedValues;
                        column.isFiltered = true;
                    } else if (column.query) {
                        map[column.termId] = [column.query];
                        column.isFiltered = true;
                    }
                } else if (column.query) {
                    map[column.termId] = [column.query];
                    column.isFiltered = true;
                }
                return map;
            }, {} as Map<string, string[]>),
            filteredTextValues: this.displayedColumns.reduce((map, column) => {
                if (!this.isTextFilter(column)) {
                    return map;
                }
                if (column.query) {
                    map[column.termId] = column.query;
                    column.isFiltered = true;
                }
                return map;
            }, {} as Map<string, string>),
            variableTypeMap: this.displayedColumns.reduce((map, column) => {
                map[column.termId] = column.variableType;
                return map;
            }, {} as Map<string, string>),
            preFilteredGids: []
        };
    }

    openBreedingMethodModal(methodId: number): void {
        this.breedingMethodModalService.openBreedingMethodModal(methodId, null);
    }

    onSelectOption(column: ColumnData, option: any): void {
        if (!option.isSelectedInFilters) {
            column.isSelectAll = false;
        }
    }

    async addVariable(variable: VariableDetails, variableTypeId: VariableTypeEnum): Promise<void> {
        if (this.currentDataset) {
            const datasetVariable: DatasetVariable = {
                variableTypeId: variableTypeId,
                variableId: parseInt(variable.id, 10),
                studyAlias: variable.alias || variable.name
            };
            try {
                if (variableTypeId === VariableTypeEnum.ENVIRONMENT_CONDITION) {
                    await this.datasetService.addEnviromentaConditions(this.studyEditorContext.studyDetails.id, this.currentDataset.datasetId, datasetVariable).toPromise();
                } else if (variableTypeId === VariableTypeEnum.ENVIRONMENT_DETAIL) {
                    await this.datasetService.addEnviromentDetails(this.studyEditorContext.studyDetails.id, this.currentDataset.datasetId, datasetVariable).toPromise();
                }
                this.studyEditorContext.existingEnvironmentLevelVariableIds.push(datasetVariable.variableId);
                const pairNameVariableId = this.variableUtilityService.getNamePairByVariableId(datasetVariable.variableId);
                if (pairNameVariableId !== datasetVariable.variableId) {
                    this.studyEditorContext.existingEnvironmentLevelVariableIds.push(pairNameVariableId);
                }
            } catch (errorResponse) {
            }
            // Schedule reload instead of immediate reload
            this.scheduleReload();
        }
    }

    async removeVariables(variables: ObservationVariable[], variableTypeId: VariableTypeEnum) {
        try {
            const variablesIds = variables.map(variable => variable.termId);
            const doContinue = await this.checkVariableHasMeasurementData(variablesIds, variableTypeId);
            if (!doContinue) {
                return;
            }

            const variablesToDelete: number[] = variables.map(variable => variable.termId);
            if (variableTypeId === VariableTypeEnum.ENVIRONMENT_CONDITION) {
                await this.datasetService.removeEnviromentConditions(this.studyEditorContext.studyDetails.id, this.currentDataset.datasetId, variablesToDelete).toPromise();
            } else if (variableTypeId === VariableTypeEnum.ENVIRONMENT_DETAIL) {
                await this.datasetService.removeEnviromentDetails(this.studyEditorContext.studyDetails.id, this.currentDataset.datasetId, variablesToDelete).toPromise();
            }

            this.studyEditorContext.existingEnvironmentLevelVariableIds = this.studyEditorContext.existingEnvironmentLevelVariableIds.filter(id => {
                const pairNameVariableId = this.variableUtilityService.getNamePairByVariableId(id);
                return !variablesIds.includes(id) && id !== pairNameVariableId;
            });
        } catch (errorResponse) {
        }
        // Schedule reload instead of immediate reload
        this.scheduleReload();
    }

    async checkVariableHasMeasurementData(variableIds: number[], variableType: VariableTypeEnum) {
        if (variableIds.length !== 0) {
            var hasData = false;
            if (variableType === VariableTypeEnum.ENVIRONMENT_CONDITION) {
                const response = await this.datasetService.observationCount(this.studyEditorContext.studyId, this.currentDataset.datasetId, variableIds).toPromise();
                const count = parseInt(response.headers.get('X-Total-Count'), 10);
                hasData = count > 0;
            } else if (variableType === VariableTypeEnum.ENVIRONMENT_DETAIL) {
                const response = await this.datasetService.hasExistingDescriptorValues(this.studyEditorContext.studyId, this.currentDataset.datasetId, variableIds).toPromise();
                hasData = response.body;
            }

            if (hasData) {
                // Show confirmation modal and handle user choice
                const modalRef = this.modalService.open(ModalConfirmComponent);
                modalRef.componentInstance.title = 'Confirmation';
                modalRef.componentInstance.message = this.translateService.instant('study-editor.study-dataset.delete-variable.variable-has-measurement-data');

                return modalRef.result
                    .then(() => true) // User confirms (true)
                    .catch(() => false); // User cancels (false)
            } else {
                return Promise.resolve(true); // Variables dont have data, return true to continue
            }
        }
        return Promise.resolve(true); // Variables dont have data, return true to continue
    };

    trackRowsById(row: ObservationUnitsSearchResponse) {
        return row.trialInstance;
    }

    trackColumnsById(column: ColumnData) {
        return column.id;
    }

    async updateObservation(entry: ObservationUnitsSearchResponse, column: ColumnData): Promise<void> {
        const trialInstance = this.trialInstances[entry.trialInstance];
        const studyId = this.studyEditorContext.studyDetails.id;
        const currentCell = this.editingCell;
        const dataModel: ObservationUnitData = currentCell.model;
        const value = currentCell.model.value ?? '';
        const previousValue = currentCell.previousValue;
        const row = currentCell.row;
        const col = currentCell.col;
        try {
            if (!dataModel) {
                return;
            }

            // Do not update if value hasn't changed.
            if (previousValue === value) {
                return;
            }
            if (this.validateValue(value)) {
                this.alertService.error('study-editor.study-dataset.error.invalid-value');
                currentCell.model.value = previousValue;
                return;
            }

            if (column.variableTypeId === VariableTypeEnum.ENVIRONMENT_DETAIL) {
                if (dataModel) {
                    const studyInstanceDescriptor: StudyInstanceDescriptor = {
                        instanceId: trialInstance.instanceId,
                        variableId: column.termId,
                        value: value,
                        categoricalValueId: this.getCategoricalValueId(value, column)
                    };
                    await this.studyInstanceService.addOrUpdateInstanceDescriptor(studyId, trialInstance.instanceId, studyInstanceDescriptor).toPromise();
                }
            } else if (column.variableTypeId === VariableTypeEnum.ENVIRONMENT_CONDITION) {
                if (dataModel) {
                    const studyInstanceObservation: StudyInstanceObservation = {
                        instanceId: trialInstance.instanceId,
                        variableId: column.termId,
                        value: value,
                        categoricalValueId: this.getCategoricalValueId(value, column)
                    };
                    await this.studyInstanceService.addOrUpdateInstanceObservation(studyId, trialInstance.instanceId, dataModel.observationId, studyInstanceObservation).toPromise();
                }
            }
        } catch (responseError) {
            // Handle any errors that might occur
            dataModel.value = previousValue;
            this.getCellData(row, col).hasError = true;

            if (responseError.error) {
                this.alertService.error('study-editor.study-environments.update-observation.error', { param: responseError.error.errors[0].message });
            } else {
                this.alertService.error('error.general');
            }
        }
    }

    private validateValue(value) {
        const invalidChars = /[<>?|%]/;
        return invalidChars.test(value);
    }

    onCellSelectedLocation(location: Location, entry: ObservationUnitsSearchResponse, column: ColumnData, row: number, col: number) {
        if (column.termId === this.LOCATION_ID_TERM_ID) {
            entry.environmentVariables[column.alias].value = location.name;
            entry.variables[column.alias].value = location.name;
            entry.variables['LOCATION_ABBR'].value = location.abbreviation;
            entry.environmentVariables['LOCATION_ABBR'].value = location.abbreviation;

        }
    }

    isColumnEditable(column: ColumnData): boolean {
        if (!this.hasAnyAuthority(MODIFY_ENVIRONMENT_VALUES_PERMISSIONS)) {
            return false;
        }
        // Only ENVIRONMENT_CONDITION/DETAILS and LOCATION variable are editable
        return column.termId === this.LOCATION_ID_TERM_ID || ((column?.variableTypeId === VariableTypeEnum.ENVIRONMENT_CONDITION || column?.variableTypeId === VariableTypeEnum.ENVIRONMENT_DETAIL))
             && !column.systemVariable;
    }

    getCellValue(entry: ObservationUnitsSearchResponse, column: ColumnData): string {
        if (!entry?.environmentVariables || !column?.name) {
            return '';
        }

        // For the Location Name, we should get the value from
        // variables map because it is where the name is stored.
        if (column.termId === this.LOCATION_ID_TERM_ID) {
            return entry.variables['LOCATION_ABBR'].value ? entry.environmentVariables[column.alias].value + ' (' + entry.variables['LOCATION_ABBR'].value + ')' : entry.environmentVariables[column.alias].value;
        }

        const property = entry.environmentVariables[column.name];
        if (property?.value === undefined || property?.value === null) {
            return '';
        }

        return String(property.value);
    }

    getModel(column: ColumnData, entry: ObservationUnitsSearchResponse) {
        if (column.termId === this.LOCATION_ID_TERM_ID) {
            return entry.environmentVariables[column.name];
        } else {
            return entry.environmentVariables[column.name];
        }
    }

    addInstances(numberOfEnvironments: number) {
        const studyId = this.studyEditorContext.studyDetails.id;
        // create and save the environment in the server
        this.studyInstanceService.createStudyInstances(studyId, numberOfEnvironments).toPromise().then((studyInstances) => {
            this.scheduleReload();
        });
    };

    isDesignAlreadyGenerated() {
        return this.studyEditorContext.hasGeneratedDesign() || this.studyEditorContext.hasListOrSubObs();
    };

    addInstanceClicked() {
        if (this.isDesignAlreadyGenerated()) {
            this.isReloadPending = true;
            this.addInstances(1);
        }
    }

    deleteInstanceClicked(entry: ObservationUnitsSearchResponse) {
        const studyId = this.studyEditorContext.studyDetails.id;
        const environmenrDatasetId = this.currentDataset.datasetId;
        const trialInstance = this.trialInstances[entry.trialInstance];

        this.studyInstanceService.getStudyInstance(studyId, trialInstance.instanceId).toPromise().then(async (studyInstance) => {
            const fileCountResp = await this.fileService.getFileCountStudy(null, environmenrDatasetId, null, null).toPromise();
            const fileCount = parseInt(fileCountResp.headers.get('X-Total-Count'), 10);

            // Show error if instance cannot be deleted
            if (!studyInstance.canBeDeleted) {
                this.alertService.error('study-editor.study-environments.environment.cannot.be.deleted');
                return;
            } else {
                let message = this.translateService.instant('study-editor.study-environments.environment.delete.no.plot.data');
                if (fileCount > 0 || studyInstance.hasMeasurements || studyInstance.hasFieldLayout || studyInstance.hasExperimentalDesign) {
                    message = this.translateService.instant('study-editor.study-environments.environment.has.plot.data');
                }

                const confirmModalRef = this.modalService.open(ModalConfirmComponent as Component);
                confirmModalRef.componentInstance.message = message;
                confirmModalRef.result.then(() => {
                    this.continueInstanceDeletion([trialInstance.instanceId]);
                });
            }
        });
    };

    // Proceed deleting existing instance
    continueInstanceDeletion(instanceIds:number[]) {
        const studyId = this.studyEditorContext.studyDetails.id;
        this.studyInstanceService.deleteStudyInstances(studyId, instanceIds).toPromise().then(()=> {
            this.alertService.success('study-editor.study-environments.environment.deleted.successfully');
            // Once the instance is deleted, we need to reload the study editor so that the study details are refreshed
            this.studyEditorService.triggerRefreshAndWait().then(() => {
                this.scheduleReload();
            });
        });
    };

    setNumberOfInstances () {
        const studyId = this.studyEditorContext.studyDetails.id;
        if (this.newNumberOfenvironments <= 0) {
            this.alertService.error('study-editor.study-environments.study.should.have.at.least.one.environment');
        } else if (this.newNumberOfenvironments > this.numberOfEnvironments) {
            const numberOfEnvironmentsToAdd = this.newNumberOfenvironments - this.numberOfEnvironments;
            this.addInstances(numberOfEnvironmentsToAdd);
        } else if (this.newNumberOfenvironments < this.numberOfEnvironments) {
            // if new instance count is less than previous value, splice array
            const countDiff =  this.numberOfEnvironments - this.newNumberOfenvironments;
            const message = this.translateService.instant('study-editor.study-environments.environment.decrease.no.plot.data', { param1: countDiff, param2: (countDiff > 1 ? 's' : '') });

            const confirmModalRef = this.modalService.open(ModalConfirmComponent as Component);
            confirmModalRef.componentInstance.message = message;
            confirmModalRef.result.then(result => {
                const instanceIds = [];
                while (Object.keys(this.trialInstances).length > this.newNumberOfenvironments) {
                    const keys = Object.keys(this.trialInstances);
                    const lastKey = keys[keys.length - 1];
                    const instance = this.trialInstances[lastKey];
                    instanceIds.push(instance.instanceId);
                    delete this.trialInstances[lastKey];
                }
                this.studyInstanceService.deleteStudyInstances(studyId, instanceIds).toPromise().then(() => {
                    this.scheduleReload();
                });
            });
        }
    };

    showDeleteIcon() {
        return this.numberOfEnvironments > 1 && this.hasAnyAuthority(MODIFY_NUMBER_OF_ENVIRONMENT_PERMISSIONS);
    }

    concatAllColumns(): ColumnData[] {
        return [
            ...this.environmentDetails,
            ...this.environmentConditions
        ];
    }

    dropColumn(event: CdkDragDrop<any[]>) {
        // Get indexes of selected columns only
        const selectedColumns = this.displayedColumns.filter(col => col.selected);
        const fromIndex = this.displayedColumns.findIndex(col => col === selectedColumns[event.previousIndex]);
        const toIndex = this.displayedColumns.findIndex(col => col === selectedColumns[event.currentIndex]);

        if (fromIndex !== -1 && toIndex !== -1) {
            moveItemInArray(this.displayedColumns, fromIndex, toIndex);
            this.columnDataService.saveColumnsState();
        }
    }

    showFiles(instanceNumber: number, variableName: string) {
        const modalRef = this.modalService.open(FileManagerComponent as Component, { size: 'xl', backdrop: 'static' });
        modalRef.componentInstance.instanceId = this.trialInstances[instanceNumber]?.instanceId;
        modalRef.componentInstance.datasetId = this.currentDataset.datasetId;
        modalRef.componentInstance.variableName = variableName;
        modalRef.result.then((result) => {
            this.scheduleReload();
        }, () => {
            this.scheduleReload();
        });
    }

    setHoveredRow(index: number | null): void {
        this.hoveredRow = index;
    }

    isFileButtonVisible(entry: ObservationUnitsSearchResponse): boolean {
        return this.isFileStorageConfigured && entry.fileCount > 0;
    }

    isFileButtonVisibleForVariable(entry: ObservationUnitsSearchResponse, variableId: string): boolean {
        return this.isFileStorageConfigured && entry.fileVariableIds?.includes(variableId);
    }

    onColumnSelectorDeselectedAll() {
        this.displayedColumns.forEach(column => {
            if (column.visible) {
                column.selected = false;
            }
        });
    }

    onColumnSelectorSelectedAll() {
        this.displayedColumns.forEach(column => {
            if (column.visible) {
                column.selected = true;
            }
        });
    }

    onColumnSelectorReset() {
        this.onColumnSelectorSelectedAll();
        this.scheduleReload();
    }

    async detachOrDeleteFilesIfAny(variables: ObservationVariable[], variableTypeId: VariableTypeEnum) {
        const variableIds = variables.map(variable => variable.termId);

        const doContinue = await this.confirmDeletionOfVariable(variableIds);
        if (!doContinue) {
            return;
        }

        if (this.isFileStorageConfigured) {
            const fileCountResp = await this.fileService.getFileCountStudy(variableIds, this.currentDataset.datasetId, null, null).toPromise();
            const fileCount = parseInt(fileCountResp.headers.get('X-Total-Count'), 10);
            if (fileCount > 0) {
                const modalInstance = this.showFileDeletionOptions(fileCount);
                modalInstance.result.then(() => {
                    this.fileService.removeFilesStudy(variableIds, this.currentDataset.datasetId, null).toPromise()
                        .then(() => {
                            this.removeVariables(variables, variableTypeId);
                        });
                }, () => {
                    this.fileService.detachFilesStudy(variableIds, this.currentDataset.datasetId, null).toPromise()
                        .then(() => {
                            this.removeVariables(variables, variableTypeId);
                        });
                });
            } else {
                this.removeVariables(variables, variableTypeId);
            }
        } else {
            this.removeVariables(variables, variableTypeId);
        }
    };

    async confirmDeletionOfVariable(variableIds: number[]) {

        const isVariableUsedInOtherCalculatedVariable = await this.checkVariableIsUsedInCalculatedVariable(variableIds);

        if (variableIds.length !== 0) {
            if (isVariableUsedInOtherCalculatedVariable) {
                // Show confirmation modal and handle user choice
                const modalRef = this.modalService.open(ModalConfirmComponent);
                modalRef.componentInstance.title = this.translateService.instant('study-editor.germplasm-checks.confirmation');
                modalRef.componentInstance.message = this.translateService.instant('study-editor.study-dataset.delete-variable.variable-is-used-in-calculated-variable');
                return modalRef.result
                    .then(() => true) // User confirms (true)
                    .catch(() => false); // User cancels (false)
            } else {
                return Promise.resolve(true); // Variables dont have data, return true to continue
            }
        }
        return Promise.resolve(true); // Variables dont have data, return true to continue
    };

    async checkVariableIsUsedInCalculatedVariable(variableIds: number[]) {
        let variableIsUsedInOtherCalculatedVariable = false;
        const responseData = await this.derivedVariableService.getFormulaVariables(this.studyEditorContext.studyId, this.studyEditorContext.getPlotDataset().datasetId).toPromise();
        //response is null if study is not yet saved
        if (responseData) {
            responseData.forEach((formulaVariable) => {
                if (variableIds.indexOf(formulaVariable.id) > -1) {
                    variableIsUsedInOtherCalculatedVariable = true;
                }
            });
        }
        return variableIsUsedInOtherCalculatedVariable;
    };

    showFileDeletionOptions(fileCount: number) {
        const confirmModalRef = this.modalService.open(ModalConfirmComponent as Component);
        confirmModalRef.componentInstance.message = this.translateService.instant('study-editor.file-delete-options.message', { param: fileCount });
        confirmModalRef.componentInstance.cancelLabel = this.translateService.instant('study-editor.file-delete-options.leave-them');
        confirmModalRef.componentInstance.confirmLabel = this.translateService.instant('study-editor.file-delete-options.delete-them');
        return confirmModalRef;
    };

    getCellClass(entry: ObservationUnitsSearchResponse, column: ColumnData): string {
        const classes = ['entry-details'];
        if (this.isColumnEditable(column)) {
            classes.push('editable');
        }
        return classes.join(' ');
    }
}



